var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgNoStock = function SvgNoStock(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.94 2.94a1.5 1.5 0 1 1 2.12 2.12L14.121 12l6.94 6.94a1.5 1.5 0 1 1-2.122 2.12L12 14.121l-6.939 6.94a1.5 1.5 0 1 1-2.12-2.122L9.878 12 2.939 5.06A1.5 1.5 0 1 1 5.06 2.94L12 9.878z"
  })));
};
export { SvgNoStock as ReactComponent };
export default "data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none' viewBox='0 0 24 24'%3e%3cpath fill='currentColor' d='M18.94 2.94a1.5 1.5 0 1 1 2.12 2.12L14.121 12l6.94 6.94a1.5 1.5 0 1 1-2.122 2.12L12 14.121l-6.939 6.94a1.5 1.5 0 1 1-2.12-2.122L9.878 12 2.939 5.06A1.5 1.5 0 1 1 5.06 2.94L12 9.878z'/%3e%3c/svg%3e";